import { hot } from 'react-hot-loader';

import { useMediaPredicate } from 'react-media-hook';
import { mobileBreakpoint } from '../helpers/Media';

import RoadmapIcon from '../components/SvgRobo/RoadmapIcon';
import RoadmapLine from '../components/SvgRobo/RoadmapLine';

import roadmapLineImg from '../assets/images/roadmap-line.svg';
import roadmap1Img from '../assets/images/roadmap/roadmap1.png';
//import roadmap2Img from '../assets/images/roadmap/roadmap2.png';
import roadmap2X2Img from '../assets/images/roadmap/roadmap2@2x.png';

import './ScreenRoadmap.scss';

import ReactPixel from 'react-facebook-pixel';
import { Observe } from 'react-observe-component';



function ScreenRoadmap() {
  const isMobile = useMediaPredicate(mobileBreakpoint);
  const isIntersecting = (entry) => {
    if (entry.isIntersecting === true) {
      ReactPixel.track('ViewContent');
    }
  }

  return (
    <Observe
      as='section'
      id='roadmap'
      className='section-roadmap'
      isIntersecting={isIntersecting}
      options={{ threshold: 0 }}
    >
      <div className="container" data-aos="fade-in" data-delay="200" data-offset="200">
        {!isMobile && <div className="roadmap-line"
          data-aos="fade-right" data-delay="500" data-offset="300"
        >
          <img
            width="424" height="1086" alt="" title="" className=""
            src={roadmapLineImg}
          />
        </div>}

        <div className="row">
          <div className="col-lg-6 col-xl-7">
            {isMobile && <div className="roadmap__img roadmap__img--1"
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
              data-delay="200"
            >
              <img
                className="img-responsive" width="760" height="340" alt="" title=""
                src={roadmap1Img}
              />
            </div>}

            <div className="roadmaps-title"
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
              data-delay="200"
            >
              <div className="pre-title"><span>roadmap</span></div>
              <h2 className="title">The rocket ride on one of <span>the most exciting</span> art adventures in the present day</h2>
              <p className="desc">The team has outlined a roadmap to ensure that any prospects smoothly sail into the project promises.</p>
            </div>

            {!isMobile && <div className="roadmap__img roadmap__img--1"
              data-aos="fade-right"
              data-aos-easing="ease-in-sine"
              data-delay="200"
            >
              <img
                className="img-responsive" width="760" height="340" alt="" title=""
                src={roadmap1Img}
              />
            </div>}

            <div className="roadmap__img roadmap__img--2">
              <img
                className="img-responsive" width="760" height="420" alt="" title=""
                //src={roadmap2Img} srcSet={`${roadmap2X2Img} 2x`}
                src={roadmap2X2Img}
              />
            </div>
          </div>

          <div className="col-lg-6 col-xl-5">
            <div className="roadmap-box">
              <div className="roadmap" data-aos="zoom-in-down" data-delay="300" data-offset="100">
                <div className="roadmap-icon"><RoadmapIcon /></div>
                <div className="roadmap-info">
                  <div>Launching the NFTs</div>
                  <span>The team prepares meticulously for the launch of the Roborovski NFTs to ensure every sale of the artwork is seamless. We will offer quality pieces of artwork to prospective buyers, getting around the gas war to ensure they sell at a fair price.</span>
                </div>
              </div>
              <div className="roadmap" data-aos="zoom-in-down" data-delay="600">
                <div className="roadmap-icon"><RoadmapIcon /></div>
                <div className="roadmap-info">
                  <div>Exploring the lore behind Roborovski</div>
                  <span>Anybody who has purchased the NFTs will have access to watch the Roborovski film to discover his origin story. The first 20 buyers can order exclusive merchandise with their unique artwork, hand-signed by the creative team.</span>
                </div>
              </div>
              <div className="roadmap" data-aos="zoom-in-down" data-delay="900">
                <div className="roadmap-icon"><RoadmapIcon /></div>
                <div className="roadmap-info">
                  <div>Shaping the future of the project</div>
                  <span>NFT owners do not only get a valued piece of art but are integral in creating the future for Roborovski. Ideas on the table include films, blockchain games, TV series, and a metaverse project. However, it’s all in your hands.</span>{/* We will get together to shape a profitable and exciting future for the revenge-driven hamster.</span>*/}
                </div>
              </div>
              <div className="roadmap" data-aos="zoom-in-down" data-delay="1200">
                <div className="roadmap-icon"><RoadmapIcon /></div>
                <div className="roadmap-info">
                  <div>Executing owner ideas</div>
                  <span>Votes on the future will take place, where the creative team will action the majority idea. Our team is full of professionals, ensuring a quality product and one that will skyrocket the Roborovski project into the stratosphere.</span>
                </div>
              </div>
              <div className="roadmap" data-aos="zoom-in-down" data-delay="1500">
                <div className="roadmap-icon"><RoadmapIcon /></div>
                <div className="roadmap-info">
                  <div>Endless possibility, limitless opportunity</div>
                  <span>There is endless potential for Roborovski.</span>{/* Owners will take solace knowing that there is a wealth of opportunity behind the project. Once we've laid the groundwork, the world is there for the hamsters taking.</span>*/}
                </div>
              </div>

              {isMobile && <div className="roadmap-line"><RoadmapLine /></div>}
            </div>
          </div>
        </div>
      </div>
    </Observe>
  );
};

export default hot(module)(ScreenRoadmap);
